import React, { useEffect, useState } from 'react';
import './ActiveUsers.css';
import { API_ENDPOINTS } from '../config/api';

const ActiveUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [past, setPast] = useState([]);
  const [totals, setTotals] = useState([]);

  const fetchUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const [resActive, resPast, resTotals] = await Promise.all([
        fetch(API_ENDPOINTS.ACTIVITY_ACTIVE_USERS),
        fetch(API_ENDPOINTS.ACTIVITY_PAST_USERS),
        fetch(API_ENDPOINTS.ACTIVITY_USAGE_TOTALS)
      ]);
      if (!resActive.ok || !resPast.ok || !resTotals.ok) throw new Error('Liste alınamadı');
      const [dataActive, dataPast, dataTotals] = await Promise.all([resActive.json(), resPast.json(), resTotals.json()]);
      setUsers(dataActive);
      setPast(dataPast);
      setTotals(dataTotals);
    } catch (e) {
      setError('Kullanıcı listeleri alınamadı.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
    const i = setInterval(fetchUsers, 30000);
    return () => clearInterval(i);
  }, []);

  return (
    <div className="active-users-container">
      <h2>Aktif Kullanıcılar</h2>
      {loading && <div className="loading-message">Yükleniyor...</div>}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && (
        <div className="active-users-table-container">
          <table className="active-users-table">
            <thead>
              <tr>
                <th>Ad Soyad</th>
                <th>E-posta</th>
                <th>Başlangıç</th>
                <th>Son Görülme</th>
                <th>Süre (dk)</th>
              </tr>
            </thead>
            <tbody>
              {users.length === 0 ? (
                <tr><td className="empty-table-message" colSpan={5}>Şu an aktif kullanıcı yok.</td></tr>
              ) : (
                users.map((u) => (
                  <tr key={u.akademisyen_id}>
                    <td>{u.name} {u.surname}</td>
                    <td>{u.email}</td>
                    <td>{new Date(u.start_time).toLocaleString('tr-TR')}</td>
                    <td>{new Date(u.last_seen).toLocaleString('tr-TR')}</td>
                    <td>{Math.max(0, Math.round(u.minutes))}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
      
      <h3>Geçmiş Oturumlar (Son 24 Saat)</h3>
      {!loading && !error && (
        <div className="active-users-table-container">
          <table className="active-users-table">
            <thead>
              <tr>
                <th>Ad Soyad</th>
                <th>E-posta</th>
                <th>Başlangıç</th>
                <th>Bitiş</th>
                <th>Süre (dk)</th>
              </tr>
            </thead>
            <tbody>
              {past.length === 0 ? (
                <tr><td className="empty-table-message" colSpan={5}>Kayıt yok.</td></tr>
              ) : (
                past.map((u) => (
                  <tr key={u.session_id}>
                    <td>{u.name} {u.surname}</td>
                    <td>{u.email}</td>
                    <td>{new Date(u.start_time).toLocaleString('tr-TR')}</td>
                    <td>{new Date(u.end_time).toLocaleString('tr-TR')}</td>
                    <td>{Math.max(0, Math.round(u.minutes))}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      <h3>Toplam Kullanım Süresi (Tüm Zamanlar)</h3>
      {!loading && !error && (
        <div className="active-users-table-container">
          <table className="active-users-table">
            <thead>
              <tr>
                <th>Ad Soyad</th>
                <th>E-posta</th>
                <th>Toplam Süre</th>
              </tr>
            </thead>
            <tbody>
              {totals.length === 0 ? (
                <tr><td className="empty-table-message" colSpan={3}>Kayıt yok.</td></tr>
              ) : (
                totals.map((u) => {
                  const minutes = Math.max(0, Math.round(u.minutes));
                  const hours = Math.floor(minutes / 60);
                  const mins = minutes % 60;
                  return (
                    <tr key={u.akademisyen_id}>
                      <td>{u.name} {u.surname}</td>
                      <td>{u.email}</td>
                      <td>{hours} saat {mins} dk</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ActiveUsers;


